import React from 'react';
import "./i18n";
import Header from './components/header/Header';
import Nav from './components/nav/Nav';
import About from './components/about/About';
import Experience from './components/experience/Experience';
import Portfolio from './components/portfolio/Portfolio';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import RevealSection from "./RevealSection"; // <- corrigido

const App = () => {
  return (
    <>
      <Nav />
      <Header />

      <RevealSection amount={0.15}>
        <About />
      </RevealSection>

      <RevealSection amount={0.15} delay={0.05}>
        <Experience />
      </RevealSection>

      <RevealSection amount={0.15} delay={0.05}>
        <Portfolio />
      </RevealSection>

      <RevealSection amount={0.15}>
        <Contact />
      </RevealSection>

      <Footer />
    </>
  );
};

export default App;
